import styled from '@emotion/styled'

import { mediaUp } from '@/styles/media'
import { colors } from '@/styles/theme'
import { LegiaBlack, Text1 } from '@/styles/typography'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

export const Title = styled(Text1)`
  color: ${colors.white};

  .legia-warszawa & {
    ${LegiaBlack};
  }
`

export const IconsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 18px;

  svg,
  img {
    width: 87px;
    height: 31px;
  }

  a:first-of-type {
    margin-inline-end: 20px;
  }

  ${mediaUp('lg')} {
    margin-top: 40px;

    svg,
    img {
      width: 170px;
      height: 58px;
    }

    a:first-of-type {
      margin-inline-end: 40px;
    }
  }
`

export const IconWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 8px;

  svg {
    width: 87px;
    height: 20px;
  }

  path {
    fill: ${colors.white};
  }

  ${mediaUp('lg')} {
    margin-top: 12px;

    svg {
      width: 200px;
      height: 40px;
    }
  }
`
